import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NotificationsService } from '../../services/notifications.service';
import { NotificationSummary } from '../../models/notification.models';

@Component({
    selector: 'app-notification-icon',
    templateUrl: './notification-icon.component.html',
    styleUrls: ['./notification-icon.component.scss'],
    standalone: false
})
export class NotificationIconComponent implements OnInit, OnDestroy {
  @Output() notificationClick = new EventEmitter<void>();
  
  notificationSummary: NotificationSummary = {
    unreadCount: 0,
    hasMore: false,
    notifications: []
  };
  
  private destroy$ = new Subject<void>();

  constructor(private notificationsService: NotificationsService) { }

  ngOnInit(): void {
    // Subscribe to notification summary updates
    this.notificationsService.notificationSummary$
      .pipe(takeUntil(this.destroy$))
      .subscribe(summary => {
        this.notificationSummary = summary;
      });

    // Start polling for notifications
    this.notificationsService.startPolling();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.notificationsService.stopPolling();
  }

  onNotificationClick(): void {
    this.notificationClick.emit();
  }

  get hasUnreadNotifications(): boolean {
    return this.notificationSummary.unreadCount > 0;
  }

  get unreadCount(): number {
    return this.notificationSummary.unreadCount;
  }

  get displayCount(): string {
    if (this.unreadCount > 99) {
      return '99+';
    }
    return this.unreadCount.toString();
  }
}
